import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { styled } from "@mui/material/styles";

const InfoIconSvg = styled(SvgIcon)`
  fill: ${(props) => (props.color ? "currentColor" : "none")};
  stroke: currentcolor;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
`;

const InfoIcon = (props) => (
  <InfoIconSvg {...props}>
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </InfoIconSvg>
);

export default InfoIcon;
